import { createPortal } from "react-dom";
import Button from "../Button";
import classes from "./GBottomSaveBar.module.css";

const GBottomSaveBar = ({
  show = false,
  onCancel,
  onSave,
  firstBtnText = "Cancel",
  secondBtnText = "Save changes",
  firstBtnDisabled = false,
  secondBtnDisabled = false,
  secondBtnLoading = false,
}) => {
  return createPortal(
    <div
      className={classes.container}
      style={{ display: show ? "flex" : "none" }}
    >
      <Button
        hierarchy="white"
        variant="outlined"
        buttonText={firstBtnText}
        onClick={onCancel}
        className="text-sm medium-font"
        buttonStyle={{
          ...buttonStyle,
          color: "#3F3F46",
          background: "#ffffff",
        }}
        disabled={firstBtnDisabled}
      />
      <Button
        hierarchy="green"
        buttonText={secondBtnText}
        onClick={onSave}
        className="text-sm medium-font"
        buttonStyle={{
          color: "#FFFFFF",
          background: "#34CB65",
          ...buttonStyle,
        }}
        disabled={secondBtnDisabled}
        isLoading={secondBtnLoading}
      />
    </div>,
    document.body
  );
};
const buttonStyle = {
  border: "1px solid #E4E4E7",
  padding: "8px 14px",
  borderRadius: "6px",
  fontSize: "14px",
  fontWeight: "medium",
  lineHeight: "20px",
};
export default GBottomSaveBar;
